import { Component, HostBinding, Input } from '@angular/core';

export enum SpinnerSize {
  SMALL = 'small',
  MID = 'mid',
  LARGE = 'large',
}

export enum SpinnerColor {
  PRIMARY = 'primary',
  GRAY = 'gray',
  LIGHT = 'light',
}

@Component({
  selector: 'fl-spinner',
  template: `
    <div
      class="Spinner"
      role="presentation"
      [attr.data-color]="overlay ? SpinnerColor.PRIMARY : color"
      [attr.data-size]="size"
    ></div>
  `,
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  SpinnerColor = SpinnerColor;

  @Input() size: SpinnerSize = SpinnerSize.MID;
  @Input() color: SpinnerColor = SpinnerColor.PRIMARY;

  @HostBinding('class.Overlay')
  @Input()
  overlay = false;

  @HostBinding('class.Overlay--forModal')
  @Input()
  overlayForModal = false;
}



// WEBPACK FOOTER //
// ./src/@freelancer/ui/spinner/spinner.component.ts